export function hasAgeRangeOverlap(
  prices: { minAge?: number; maxAge?: number }[],
): boolean {
  for (let i = 0; i < prices.length; i++) {
    for (let j = i + 1; j < prices.length; j++) {
      const a = prices[i];
      const b = prices[j];
      if (
        a.minAge != null &&
        a.maxAge != null &&
        b.minAge != null &&
        b.maxAge != null &&
        a.minAge <= b.maxAge &&
        b.minAge <= a.maxAge
      ) {
        return true;
      }
    }
  }
  return false;
}
